import React from 'react'

import { ProgressBarSteps } from 'src/Libs/shop/types'
import { useShopNormalSystemConfigurationCard } from '../hooks/use-shop-normal-system-configuration'
import SystemConfigurationCard from '../../SystemConfigurationCard'

interface NormalSystemConfigurationCardProps {
  showMobile: boolean
  progress: number
  onClose: () => void
  navigateTo: (page: ProgressBarSteps) => void
}

/*
 * Wrapper for system configuration summary card using normal configuration data
 */
const NormalSystemConfigurationCard: React.FC<NormalSystemConfigurationCardProps> = ({ showMobile, progress, onClose, navigateTo }) => {
  const {
    basicData,
    mainComponent,
    deliveryDate,
    selectedPowerMeters,
    selectedBattery,
    selectedSmartMeter,
    totalPrice,
    discountedPrice,
    basicSystemImageUrl,
    selectedMainComponents,
  } = useShopNormalSystemConfigurationCard()

  return (
    <SystemConfigurationCard
      showMobile={showMobile}
      progress={progress}
      onClose={onClose}
      navigateTo={navigateTo}
      basicData={basicData}
      mainComponent={mainComponent}
      selectedPowerMeters={selectedPowerMeters}
      selectedBattery={selectedBattery}
      selectedSmartMeter={selectedSmartMeter}
      totalPrice={totalPrice}
      discountedPrice={discountedPrice}
      basicSystemImageUrl={basicSystemImageUrl}
      deliveryDate={deliveryDate}
      selectedMainComponents={selectedMainComponents}
    />
  )
}

export default NormalSystemConfigurationCard
